module.exports = __webpack_public_path__ + "static/img/moment3.581d8c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/moment3.png
// module id = mJVN
// module chunks = 1